import { storeMasterData } from "../actionTypes"

// Merges a patch into the Store Master page state.
export const setStoreMaster = (data) => {
    return {
        type: storeMasterData.MERGE,
        payload: data
    }
}
